export const SET_FILTER = "SET_FILTER";
export const GET_PRO_ORDERS = "GET_PRO_ORDERS";
export const SET_PRO_ORDER_STATUS = "SET_PRO_ORDER_STATUS";
